import { HttpClient, HttpClientConfig } from "../HttpClient";

export const API_URL = `${process.env.REACT_APP_URL}/v1`;

export class UsersLoader {
  static post<T = void>(config: HttpClientConfig) {
    return new HttpClient<T>({ baseURL: API_URL, ...config }).post();
  }

  static get<T = void>(config: HttpClientConfig) {
    return new HttpClient<T>({ baseURL: API_URL, ...config }).get();
  }

  static patch<T = void>(config: HttpClientConfig) {
    return new HttpClient<T>({ baseURL: API_URL, ...config }).patch();
  }

  static delete<T = void>(config: HttpClientConfig) {
    return new HttpClient<T>({ baseURL: API_URL, ...config }).delete();
  }
}
